import { Link } from "react-router";
import { all_routes } from "../../router/all_routes";

interface Props {
    activeTab:  'Chat' | 'AssessmentGenerator' | 'SyllabusGenerator' | 'Storage';
}

const CommonTabMenu = ({activeTab}:Props) => {
    const routes = all_routes;


    return (
               <ul className="nav nav-tabs nav-tabs-solid bg-transparent border-bottom mb-3">
                 <li className={`nav-item`}>
                     <Link className={`nav-link ${activeTab === 'Chat' ? 'active' : ''}`} to={routes.chatSettings}>
                     <i className="ti ti-messages me-2" />
                     Chat Bot
                     </Link>
                 </li>
                 <li className={`nav-item`}>
                     <Link className={`nav-link ${activeTab === 'AssessmentGenerator' ? 'active' : ''}`} to={routes.agSettings}>
                     <i className="ti ti-clipboard-check me-2" />
                     Assessment Generator
                     </Link>
                 </li>
                 <li className={`nav-item`}>
                     <Link className={`nav-link ${activeTab === 'SyllabusGenerator' ? 'active' : ''}`} to={routes.sgSettings}>
                     <i className="ti ti-notebook me-2" />
                     Syllabus Generator
                     </Link>
                 </li>
                 <li className={`nav-item`}>
                     <Link className={`nav-link ${activeTab === 'Storage' ? 'active' : ''}`} to={routes.storageSettings}>
                     <i className="ti ti-database me-2" />
                     Storage
                     </Link>
                 </li>
               </ul>
    )
}

export default CommonTabMenu;